import React from 'react'
import Button from '../Form/Button'

export default function PopupViewButton({handler, popup}) {
  return (
    <button onClick={handler} className="btn btn-primary" data-bs-toggle="modal" data-bs-target={`#${popup}`}><i className="fas fa-eye"></i></button>
  )
}
